import { GET } from "../util";

const trackingUrl = "progress/sign-up";
const url = {
    start: `${trackingUrl}/start`,
    nextStep: `${trackingUrl}/next-step`,
    submit: `${trackingUrl}/submit`
};

const signUpTrackingApi = {
    trackStart: function() {
        return GET(url.start);
    },
    trackNextStep: function(tag) {
        return GET(url.nextStep + "/" + tag);
    },
    trackSubmitSuccess: function() {
        return GET(url.submit + "/success");
    },
    trackSubmitFailure: function() {
        return GET(url.submit + "/failure");
    },
};
export {
    signUpTrackingApi
};